<template>
    <div class="load-mask-parent">
        <component-title
            :config="config">
        </component-title>
        <div :class="loadMask"></div>
        <div>
            <data-table
                :my-ajax="dataTableAjax"
                :dt-id="gridId"
                :row-id="'product_id'"
                :columns="columns"
                :column-defs="columnDefs()"
                :refresh="DTRefresh"
                :refresh-view-with-preserve-paging="DTRefreshWithPreservePaging"
                on-click-element=".row-details"
                :on-click-element-event="onClickEvent"
                :on-page-change="onPageChange"
                :sort="defaultSort.length > 0"
                :order="defaultSort"
                :page-length="pagination"
            ></data-table>
        </div>
        <div class="grid-component-components">
            <template v-for="component in getComponents">
                <component
                    :is="loadComponent(component.type)"
                    :config="component.config"
                    :parent-state="state"
                >
                </component>
            </template>
            <div class="pagination-parent" v-if="showPagination">
                <span>{{ t('Pages on side') }}:</span>
                <select v-model="pagination" class="pagination" @change="paginationChange">
                    <option v-for="_pagination in [10, 50, 100, 300, 500]" v-bind:value="_pagination">{{
                            _pagination
                        }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>
<script>

import Vue from "vue";
import DataTable from "./DataTable";
import ColumnVisitor from "../services/product/columnVisitor";
import State from "@/Models/State.ts";
import ComponentTitle from "@/components/ComponentTitle.vue";

export default {
    components: {ComponentTitle, DataTable},
    props: {
        config: {
            Type: Object,
            default: function () {
                return {
                    actionButtons: [],
                    columns: [],
                    index: null,
                    emitEvents: {},
                    components: [],
                    countUrl: null,
                    loadUrl: null,
                    refreshRowUrl: null,
                    limit: 10,
                    position: null,

                }
            }
        },
        eventBus: {
            Type: Object,
        },
        routeParams: {
            Type: Object
        },
        eventData: {
            Type: Object
        },
        queryParams: {
            Type: Object,
        },
        moduleName: {
            Type: String,
        },
    },
    computed: {
        gridId() {
            return this.config.index + '_' + this.index;
        },
        showPagination() {
            return typeof this.config.showPagination !== 'undefined' ? this.config.showPagination : true;
        },
        getComponents() {
            return this.components.filter(c => c.config.display).sort((a, b) => a.config.position - b.config.position);
        },
    },
    data() {
        return {
            storage: {},
            columns: [],
            DTRefresh: false,
            DTRefreshWithPreservePaging: false,
            pagination: null,
            defaultSort: [],
            calculatePagination: true,
            responseData: {
                data: [],
                recordsTotal: null,
                recordsFiltered: null,
            },
            mountedHeadersComponents: [],
            loadMask: '',
            state: new State(),
            loadUrl: null,
            countUrl: null,
            componentIndex: null,
            loading: false,
            components: [],
        };
    },
    beforeDestroy() {
        this.unmountEvents();
        this.destroyRowComponents();
    },
    inject: ['eventManager', 'eventSourceService'],
    mounted() {
        this.init();

        if (this.routeParams) {
            this.setState(this.routeParams);
        }

        if (this.eventData) {
            this.setState(this.eventData);
        }

        this.mountEvents();
        this.eventManager.emitEvents(this.config.emitEvents['mounted'] || [], []);
    },
    methods: {
        destroyRowComponents() {
            for (const [key, value] of Object.entries(this.storage)) {
                value.$destroy();
            }
        },
        init() {
            this.componentIndex = this.config.index;
            this.columns = this.prepareColumns(this.config.columns);
            this.pagination = this.config.limit;
            this.components = this.config.components;
        },
        columnDefs() {
            return ColumnVisitor.visit(this.columns, {});//FIX embeded-modules
        },
        afterScrollEvent(config, data) {
            this.mountComponentsForHeader(this.columns);
        },
        loadComponent(type) {
            return require(`./buttons/${type}.vue`);
        },
        prepareColumns(columns) {
            return columns.filter(c => {
                return typeof c.display === 'undefined' ? true : c.display;
            }).sort((a, b) => {
                let aPosition = a.position || 0;
                let bPosition = b.position || 0;

                return aPosition - bPosition;
            });
        },
        async dataTableAjax(data, callback) {
            if (this.loading) {
                return;
            }

            this.loading = true;
            this.addLoadMask();
            data.offset = data.start;
            data.limit = this.pagination;
            delete data.search;
            delete data.columns;
            delete data.start;
            delete data.length;
            data = Object.assign(this.state.value, data);

            let loadUrl = this.config['loadUrl'];
            let response = await this.fetchData(loadUrl, data);
            this.responseData.data = response.data.data;

            if (null === this.responseData.recordsTotal) {
                this.responseData.recordsTotal = response.data.recordsTotal;
                this.responseData.recordsFiltered = response.data.recordsFiltered;
            }

            await callback(this.responseData);
            this.mountComponentsForColumns(this.columns, this.responseData.data);

            if (this.calculatePagination && this.config['countUrl']) {
                let countUrl = this.config['countUrl'];
                let response = await this.fetchData(countUrl, data);

                this.responseData.recordsTotal = response.data.recordsTotal;
                this.responseData.recordsFiltered = response.data.recordsFiltered;
                this.responseData.draw = 'page';

                this.$store.commit('setState', {componentIndex: this.componentIndex, data: {totalRows: response.data.recordsFiltered}});
                await callback(this.responseData);
                this.mountComponentsForColumns(this.columns, this.responseData.data);
            }

            this.afterScrollEvent();
            this.removeLoadMask();
            this.loading = false;
        },
        async fetchData(loadUrl, data) {
            return await this.$http.get(loadUrl, {params: data});
        },
        addLoadMask() {
            this.loadMask = 'lmask';
        },
        removeLoadMask() {
            this.loadMask = '';
        },
        defaultBindEvents() {
            return [{
                name: 'load',
                componentIndex: this.componentIndex,
            },{
                name: 'refreshView',
                componentIndex: this.componentIndex,
            },{
                name: 'refreshRow',
                componentIndex: this.componentIndex,
            }];
        },
        mountEvents() {
            this.eventManager.bindEvents(this.defaultBindEvents(), this);
        },
        unmountEvents() {
            this.eventManager.unbindEvents(this.defaultBindEvents());
        },
        onClickEvent: function (rowId, row, e, data) {
            let tr = $(e.target).closest('tr');
            let icon = tr.find('.row-details .glyphicon');
            if (row.child.isShown()) {
                row.child.hide();
                icon.addClass('glyphicon-chevron-down');
                icon.removeClass('glyphicon-chevron-up')
            } else {
                icon.addClass('glyphicon-chevron-up');
                icon.removeClass('glyphicon-chevron-down')
                row.child(() => {
                    return '<div class="loading-fragment"><div class="dataTables_processing panel panel-default">' + this.$translate.text('Processing') + '...</div></div>';
                }).show();
                let $el = $(row.child()[0]).find('div')[0];

                this.$root.$emit('Grid:row-onclick', this.config.index, rowId, row, $el, data);
            }
        },
        onPageChange() {
            this.calculatePagination = false;
        },
        paginationChange() {
            this.calculatePagination = false;
        },
        getDefaultHeaderComponent(column) {
            return {
                name: 'DefaultHeaderComponent',
                config: {
                    name: column.name,
                    title: column.title,
                    i18nParams: column.i18nParams
                }
            };
        },
        mountComponentsForHeader(columns) {
            let _this = this;
            columns.forEach((column, columnIndex) => {
                column.headerComponents = column.headerComponents || [this.getDefaultHeaderComponent(column)];

                column.headerComponents.forEach(function (c, i) {
                    require([`./grid/${c.name}.vue`], (r) => {
                        if (_this.mountedHeadersComponents.includes('header-' + _this.gridId + '-' + columnIndex)) {
                            return;
                        }

                        let TemplateLoader = Vue.extend(r);
                        let comp = new TemplateLoader({
                            propsData: {
                                eventBus: _this.eventBus,
                                columnIndex: columnIndex,
                                name: column.name,
                                columnIdentify: column.data,
                                config: c.config || {},
                                parentIndex: _this.config['index']
                            }
                        }).$mount();
                        let el = document.getElementById('header-' + _this.gridId + '-' + columnIndex);

                        if (!el) {
                            return;
                        }

                        el.innerHTML = '';
                        el.appendChild(comp.$el);
                        _this.mountedHeadersComponents.push('header-' + _this.gridId + '-' + columnIndex);
                    });
                });
            });

        },
        mountComponentsForColumns(columns, rows) {
            let _this = this;
            columns.forEach((c, columnIndex) => {
                if (!c.components || c.components.length === 0) {
                    return;
                }

                rows.forEach(function (row, rowIndex) {
                    require([`./grid/GridComponentFactory.vue`], (r) => {
                        let t = _this.storage[`components_${columnIndex}_${rowIndex}`];

                        if (t) {
                            t.$destroy();
                        }

                        let TemplateLoader = Vue.extend(r);

                        t = new TemplateLoader({
                            propsData: {
                                column: c,
                                state: _this.state,
                                components: c.components,
                                embeddedModules: [], //FIX embeded-modules
                                eventBus: _this.eventBus,
                                row: row,
                                routeName: _this.routeName,
                                columnIndex: columnIndex,
                                rowIndex: rowIndex,
                                eventSourceService: _this.eventSourceService,
                                eventManager: _this.eventManager,
                                parentState: _this.state,
                                parent: _this,
                            }
                        });
                        _this.storage[`components_${columnIndex}_${rowIndex}`] = t;

                        t.$mount(document.getElementById(`components_${columnIndex}_${rowIndex}`));
                    });
                });
            });
        },
        load(eventData, data) {
            this.calculatePagination = true;
            this.setState(data);
            this.refreshView();
        },
        refreshView() {
            this.DTRefresh = !this.DTRefresh;
        },
        setState(data) {
            this.state.value = data;
            this.$store.commit('setState', {componentIndex: this.componentIndex, data: {filters: this.state.value}});
        },
        findRowIndex(row, identityField) {
            let searchValue = row[identityField];

            return this.responseData.data.findIndex(r => r[identityField] === searchValue);
        },
        getRowIdentityField() {
            return this.config.rowIdentityField || 'id';
        },
        async refreshRow(eventData, data) {
            let rowIdentityField = this.getRowIdentityField();
            let response = await this.fetchData(this.config['refreshRowUrl'], data);
            let index = this.findRowIndex(data, rowIdentityField);

            if (index === -1) {
                return;
            }

            Object.assign(this.responseData.data[index], response.data);
        }
    },
}

</script>

<style lang="sass" scoped>
    .pagination-parent span {
        padding: 0 5px;
    }
    .pagination {
        border-color: #e9e9e9;
        margin-top: 0;
        margin-bottom: 5px;
        height: 40px;
        padding-left: 5px;
    }
    .grid-component-components {
        padding-top: 10px;
        position: sticky;
        bottom: 0px;
        background-color: white;
    }
    .grid-component-components > div {
        margin-right: 3px;
    }
</style>



// WEBPACK FOOTER //
// GridComponent.vue?cf8713b0